"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgricultureCreationRequest = void 0;
const agricultureConstants_1 = require("../constants/agricultureConstants");
class AgricultureCreationRequest {
    constructor() {
        this.agricultureConstants = new agricultureConstants_1.AgricultureConstants();
    }
}
exports.AgricultureCreationRequest = AgricultureCreationRequest;
